import { render, staticRenderFns } from "./navbar.vue?vue&type=template&id=351943a4&scoped=true&"
import script from "./navbar.vue?vue&type=script&lang=ts&"
export * from "./navbar.vue?vue&type=script&lang=ts&"
import style0 from "./navbar.vue?vue&type=style&index=0&id=351943a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351943a4",
  null
  
)

export default component.exports